import { clone, filter } from 'lodash';
import { CALL_API } from 'middlewares/api';
import { url } from 'configs/';
import { COMPANY_ID_DIOR } from 'configs/company';

const {
  NEWTUBE_API_SERVER,
} = url;

const FETCH_AVAILABLE_LINKS_REQUEST = 'tube/LinksSetting/FETCH_AVAILABLE_LINKS_REQUEST';
const FETCH_AVAILABLE_LINKS_SUCCESS = 'tube/LinksSetting/FETCH_AVAILABLE_LINKS_SUCCESS';
const FETCH_AVAILABLE_LINKS_FAIL = 'tube/LinksSetting/FETCH_AVAILABLE_LINKS_FAIL';
const FETCH_FAVORITE_LINKS_REQUEST = 'tube/LinksSetting/FETCH_FAVORITE_LINKS_REQUEST';
const FETCH_FAVORITE_LINKS_SUCCESS = 'tube/LinksSetting/FETCH_FAVORITE_LINKS_SUCCESS';
const FETCH_FAVORITE_LINKS_FAIL = 'tube/LinksSetting/FETCH_FAVORITE_LINKS_FAIL';
const SET_FAVORITE_LINKS_REQUEST = 'tube/LinksSetting/SET_FAVORITE_LINKS_REQUEST';
const SET_FAVORITE_LINKS_SUCCESS = 'tube/LinksSetting/SET_FAVORITE_LINKS_SUCCESS';
const SET_FAVORITE_LINKS_FAIL = 'tube/LinksSetting/SET_FAVORITE_LINKS_FAIL';
const ADD_FAVORITE_LINK = 'tube/LinksSetting/ADD_FAVORITE_LINK';
const REMOVE_FAVORIT_LINK = 'tube/LinksSetting/REMOVE_FAVORIT_LINK';

export default function reducer(state = {
  isLoading: false,
  isSubmiting: false,
  availableLinks: {
    isLoaded: false,
    linkTypes: [],
  },
  favoritelinks: {
    isLoaded: false,
    links: [],
  },
}, action) {
  switch (action.type) {
    case FETCH_FAVORITE_LINKS_REQUEST:
    case FETCH_AVAILABLE_LINKS_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case FETCH_AVAILABLE_LINKS_SUCCESS:
      {
        const linkTypesData = action.response.data;
        if (COMPANY_ID_DIOR.indexOf(sessionStorage.company_id) > -1) {
          for (let typeIndex = 0; typeIndex < linkTypesData.length; typeIndex++) {
            if (linkTypesData[typeIndex].typeName === 'SH_Employee') {
              const linkTypesEmployeeData = linkTypesData[typeIndex].links.linkUp.filter((data) => {
                return data.href !== '/tube/orders/active';
              });
              linkTypesData[typeIndex].links.linkUp = linkTypesEmployeeData;
            }
          }
        }
        const availableLinks = Object.assign({},
          state.availableLinks, {
            isLoaded: true,
            linkTypes: linkTypesData,
          });
        const newState = Object.assign({}, state, {
          isLoading: !state.favoritelinks.isLoaded,
          availableLinks,
        });
        return newState;
      }
    case FETCH_FAVORITE_LINKS_SUCCESS:
      {
        let linksData = action.response.data;
        if (COMPANY_ID_DIOR.indexOf(sessionStorage.company_id) > -1) {
          linksData = linksData.filter((data) => {
            return data.href !== '/tube/orders/active';
          });
        }
        const favoritelinks = Object.assign({},
          state.favoritelinks, {
            isLoaded: true,
            links: linksData,
          });
        const newState = Object.assign({}, state, {
          isLoading: !state.availableLinks.isLoaded,
          favoritelinks,
        });
        return newState;
      }
    case SET_FAVORITE_LINKS_REQUEST:
      return Object.assign({}, state, {
        isSubmiting: true,
      });
    case SET_FAVORITE_LINKS_SUCCESS:
      return Object.assign({}, state, {
        isSubmiting: false,
      });
    case ADD_FAVORITE_LINK:
      {
        const favoritelinks = clone(state.favoritelinks);
        const links = clone(favoritelinks.links);
        links.push(action.link);
        favoritelinks.links = links;
        return Object.assign({}, state, {
          favoritelinks,
        });
      }
    case REMOVE_FAVORIT_LINK:
      {
        const favoritelinks = clone(state.favoritelinks);
        const links = filter(favoritelinks.links, (link) => {
          return link.linkId !== action.linkId;
        });
        favoritelinks.links = links;
        return Object.assign({}, state, {
          favoritelinks,
        });
      }
    default:
      return state;
  }
}

export function fetchAvailableLinks() {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'user/links',
      types: [
        FETCH_AVAILABLE_LINKS_REQUEST,
        FETCH_AVAILABLE_LINKS_SUCCESS,
        FETCH_AVAILABLE_LINKS_FAIL,
      ],
    },
  };
}

export function fetchFavoriteLinks() {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'user/favoritelinks',
      types: [
        FETCH_FAVORITE_LINKS_REQUEST,
        FETCH_FAVORITE_LINKS_SUCCESS,
        FETCH_FAVORITE_LINKS_FAIL,
      ],
    },
  };
}

export function updateFavoriteLinks() {
  return (disptach, getState) => {
    return disptach({
      [CALL_API]: {
        url: NEWTUBE_API_SERVER + 'user/favoritelinks',
        method: 'POST',
        params: getState().app.tube.linksSetting.favoritelinks.links,
        types: [
          SET_FAVORITE_LINKS_REQUEST,
          SET_FAVORITE_LINKS_SUCCESS,
          SET_FAVORITE_LINKS_FAIL,
        ],
      },
    });
  };
}

export function addFavoriteLinks(link) {
  return {
    type: ADD_FAVORITE_LINK,
    link,
  };
}

export function removeFavoriteLinks(linkId) {
  return {
    type: REMOVE_FAVORIT_LINK,
    linkId,
  };
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/screens/LinksSetting/reducers/index.js
 **/